<template>
  <section class="a-cover lg:flex overflow-y-auto lg:overflow-hidden scrollbar">
    <div
      class="lg:h-full lg:w-96 xl:w-144 bg-white lg:flex-none lg:overflow-y-auto scrollbar"
    >
      <div class="bg-grey-1">
        <div class="flex-a p-x h-12 md:h-16">
          <Breadcrumbs />
        </div>
        <h1
          class="flex-a p-x h-12 lg:h-16 font-medium"
          v-html="'Guided tour'"
        />
      </div>
      <div class="p-x py-5 b-t-secondary">
        <img :src="image.src" alt="image.alt" class="w-full h-auto mb-6" />
        <h2 class="mb-3 text-secondary" v-html="tour.subtitle" />
        <p v-html="tour.description" />
        <Button
          v-if="!mobile"
          :text="tour.start_button_copy"
          :path="path"
          :append="true"
          class="btn btn-primary mt-4"
        />
      </div>
    </div>

    <div
      class="pt-10 lg:pb-28 lg:py-40 lg:h-full lg:w-full lg:overflow-y-auto scrollbar"
    >
      <TourStops :tour="tour" />
    </div>

    <div v-if="mobile" class="pt-6 pb-12 bg-accent-3-90 flex-c w-full">
      <Button
        v-if="mobile"
        :text="tour.start_button_copy"
        :path="path"
        :append="true"
        class="flex-c w-80% md:w-50% btn btn-primary"
      />
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import Button from '@/components/buttons/Button.vue'
import TourStops from '@/components/TourStops.vue'

export default {
  name: 'TourIntro',

  components: {
    Breadcrumbs,
    TourStops,
    Button
  },

  props: {
    tour: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState(['touch', 'mobile', 'phone']),
    ...mapGetters(['level']),

    path() {
      return this.tour?.children[0]?.slug || ''
    },

    image() {
      if (this.tour.image)
        return {
          src: this.tour.image.sizes.medium,
          alt: this.tour.image.alt
        }
      return ''
    }
  }
}
</script>

<style>
.gradient {
  background: rgb(2, 0, 36);
  background: linear-gradient(
    0deg,
    rgba(2, 0, 36, 1) 0%,
    rgba(0, 80, 114, 1) 37%,
    rgba(0, 50, 95, 0) 100%
  );
}
</style>
